import { TableSortLabel } from '@material-ui/core';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

import useNoFirstRenderEffect from '../../../hooks/useNoFirstRenderEffect';
import useRouter from '../../../hooks/useRouter';
import TableHeadCell from './TableHeadCell';

const ORDER_LIST = [{ order: 'ASC' }, { order: 'DESC' }];

const TableHeadCellOrder = ({ children, order: label, ...props }) => {
  const [index, setIndex] = useState(-1);
  const { searchParams, updateSearchParams } = useRouter();
  const { order = [] } = searchParams;

  const handleClick = () => {
    setIndex(index + 1 > ORDER_LIST.length - 1 ? 0 : index + 1);
  };

  useNoFirstRenderEffect(() => {
    if (index >= 0) {
      updateSearchParams({
        order: [{ field: label, value: ORDER_LIST[index].order }],
      });
    }
  }, [index]);

  useEffect(() => {
    const active = label === order?.[0]?.field;

    if (!active) {
      setIndex(-1);
    }
  }, [JSON.stringify(order)]);

  return (
    <TableHeadCell {...props}>
      <TableSortLabel
        active={label === order?.[0]?.field}
        direction={order?.[0]?.value?.toLowerCase()}
        onClick={handleClick}
      >
        {children}
      </TableSortLabel>
    </TableHeadCell>
  );
};

TableHeadCellOrder.propTypes = {
  order: PropTypes.string,
  children: PropTypes.node,
};

export default TableHeadCellOrder;
